import React from 'react'
import { ListPanel } from '@sukiai/components'
import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE } from '../../lib/constants'
import { HELP, SUKI } from './constants'

const ListPanelWrapper = (props) => {
  const isSmallWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.AGENT_SMALL_WIDTH})`
  })

  const isCrampedWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.AGENT_CRAMPED_WIDTH})`
  })

  return (
    <ListPanel
      type={HELP}
      title={`${SUKI} ${HELP}`}
      isSmallWindow={isSmallWindow}
      isCrampedWindow={isCrampedWindow}
      renderChildElems={props.renderChildElems}
    />
  )
}

export default ListPanelWrapper
